import LogoMark from "@/components/LogoMark";

export default function Footer({ t, onNavigate }) {
    const year = new Date().getFullYear();
    const links = [
        { id: "#portfolio", label: t.nav.work },
        { id: "#sluzby", label: t.nav.services },
        { id: "#proces", label: t.nav.process },
        { id: "#kontakt", label: t.nav.contact },
    ];

    return (
        <footer data-testid="footer-container" className="relative z-10 overflow-hidden border-t border-white/5 px-5 sm:px-8 pt-16">
            <div className="mx-auto max-w-6xl">
                <div className="flex flex-col gap-10 pb-14 md:flex-row md:items-start md:justify-between">
                    <div className="max-w-sm">
                        <div className="flex items-center gap-3">
                            <LogoMark size={26} />
                            <span className="font-display text-lg font-medium tracking-wide">
                                Webryno <span className="text-glacier">Studio</span>
                            </span>
                        </div>
                        <p className="mt-4 text-sm text-fog">{t.footer.tagline}</p>
                    </div>
                    <nav className="flex flex-wrap gap-x-8 gap-y-3">
                        {links.map((l) => (
                            <button
                                key={l.id}
                                data-testid={`footer-link-${l.id.slice(1)}`}
                                onClick={() => onNavigate(l.id)}
                                className="font-mono text-[11px] uppercase tracking-[0.22em] text-fog transition-colors duration-300 hover:text-ivory"
                            >
                                {l.label}
                            </button>
                        ))}
                    </nav>
                </div>

                <div
                    aria-hidden="true"
                    className="pointer-events-none select-none text-center font-display font-medium leading-[0.85] tracking-tight text-ivory/[0.045] text-[clamp(4rem,17vw,15rem)]"
                >
                    Webryno
                </div>

                <div className="flex flex-col items-center justify-between gap-3 border-t border-white/5 py-6 sm:flex-row">
                    <p data-testid="footer-copyright-text" className="font-mono text-[10px] uppercase tracking-[0.2em] text-fog/70">
                        © {year} {t.footer.rights}
                    </p>
                    <div className="flex items-center gap-5">
                        <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-fog/50">Slovensko · SK</p>
                        <a
                            data-testid="footer-admin-link"
                            href="/admin"
                            className="font-mono text-[10px] uppercase tracking-[0.2em] text-fog/40 transition-colors duration-300 hover:text-glacier"
                        >
                            Admin
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    );
}
